import { useContext } from "react";
import { KindOfOrder } from "../../../../types/enums";
import AddNoteButton from "../../../common/notes/components/AddNoteButton";
import { EstimateContext, RefetchScope } from "../context/EstimateContext";

export default function EstimateAddNoteButton() {

	const { order, refetchOrder } = useContext(EstimateContext);

	var companyIDs = [order.details.dealerID]
	if (order.details.cfiID) {
		companyIDs.push(order.details.cfiID);
	}

	const params = {
		showNoteType: false,
		orderID: order.details.quoteID,
		kindOfOrder: KindOfOrder.Estimate,
		companyIDs: companyIDs,
		emailSubject: order.details.quoteNumber,
		onNoteAdded: () => refetchOrder(RefetchScope.Notes)
	}

	return (
		<>
			<AddNoteButton
				caption="Add Note"
				params={params}
			/>
		</>
	)
}
